"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var g2_1 = require("@antv/g2");
var util_1 = require("@antv/util");
var MARGIN = 10;
var AreaLineElementLabels = /** @class */ (function (_super) {
    tslib_1.__extends(AreaLineElementLabels, _super);
    function AreaLineElementLabels() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AreaLineElementLabels.prototype.showLabels = function (points, shapes) {
        var _this = this;
        var labelPoints = [];
        util_1.each(shapes, function (shape) {
            var originData = shape.get('origin');
            var lastPoint = util_1.deepMix({}, originData[originData.length - 1]);
            var bbox = shape.getBBox();
            lastPoint.x = bbox.maxX + MARGIN;
            lastPoint.y = lastPoint.y[1];
            labelPoints.push(lastPoint);
        });
        _super.prototype.showLabels.call(this, labelPoints, shapes);
        var renderer = this.get('labelsRenderer');
        var labels = renderer.get('group').get('children');
        var view = this.get('element').get('view');
        util_1.each(labels, function (label) {
            label.attr('textAlign', 'left');
            label.attr('textBaseline', 'middle');
            var origin = label.get('origin');
            var shapeId = _this.get('element').getShapeId(origin);
            var color = _this._adjustColor(shapeId, shapes);
            label.attr('fill', color);
        });
        view.get('canvas').draw();
    };
    AreaLineElementLabels.prototype._adjustColor = function (shapeId, shapes) {
        var color;
        util_1.each(shapes, function (shape) {
            var id = shape.id;
            if (id === shapeId) {
                color = shape.attr('fill');
            }
        });
        return color;
    };
    return AreaLineElementLabels;
}(g2_1.ElementLabels));
g2_1.registerElementLabels('areaLine', AreaLineElementLabels);
//# sourceMappingURL=line-label.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/stack-area/component/label/line-label.js
// module id = 977
// module chunks = 37